import React, { forwardRef } from 'react';
import { cn } from '@bem-react/classname';
import { usePreventScroll } from '@use-platform/react/interactions/prevent-scroll/usePreventScroll';
import { CloseButton } from '../CloseButton';
import './Dialog.css';
var cnDialog = cn('UserWidget', 'Dialog');
export var Dialog = forwardRef(function (props, ref) {
    var visible = props.visible, loading = props.loading, colorScheme = props.colorScheme, platform = props.platform, onClose = props.onClose;
    usePreventScroll({ enabled: visible && platform === 'touch' });
    return (React.createElement("div", { role: "dialog", "aria-busy": loading, "aria-modal": "true", className: cnDialog('Dialog', {
            visible: visible,
            loading: loading,
            colorScheme: colorScheme,
            platform: platform,
        }), ref: ref },
        loading && React.createElement(CloseButton, { colorScheme: colorScheme, onClick: onClose }),
        props.children));
});
